import script from "./OpalButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpalButton.vue?vue&type=script&setup=true&lang=ts"

import "./OpalButton.vue?vue&type=style&index=0&id=476ba9e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-476ba9e9"]])

export default __exports__